import React from "react";
import PropTypes from "prop-types";

import ShapeListOption from "./ShapeListOption";

import { SHAPES } from "./constants";

const ShapeList = ({ handleShapeSelect, currentShape }) => {
    return (
        <>
            <ShapeListOption
                handleShapeSelect={handleShapeSelect}
                currentShape={currentShape}
                optionShape={SHAPES.SQUARE}
            >
                Square
            </ShapeListOption>
            <ShapeListOption
                handleShapeSelect={handleShapeSelect}
                currentShape={currentShape}
                optionShape={SHAPES.ROUNDED}
            >
                Rounded
            </ShapeListOption>
            <ShapeListOption
                handleShapeSelect={handleShapeSelect}
                currentShape={currentShape}
                optionShape={SHAPES.CIRCLE}
            >
                Circle
            </ShapeListOption>
            <ShapeListOption
                handleShapeSelect={handleShapeSelect}
                currentShape={currentShape}
                optionShape={SHAPES.RING}
            >
                Ring
            </ShapeListOption>
        </>
    );
};

ShapeList.propTypes = {
    handleShapeSelect: PropTypes.func.isRequired,
    currentShape: PropTypes.string.isRequired
};

export default ShapeList;
